import { Component } from 'react';

import QuickReplyList from '../containers/QuickReplyList';
import type { Button } from '../types/ChatWindow';
import type { MenuProps } from '../types/configs';
import PoweredBy from './PoweredBy';

class Menu extends Component<MenuProps, unknown> {
  handleClick = (clickedButton: Button) => {
    const { handleMenuClick } = this.props;
    handleMenuClick(clickedButton);
  };

  render() {
    const {
      menuTemplate,
      show,
      scheme: { message: messageScheme },
    } = this.props;

    return (
      <>
        {show &&
          menuTemplate &&
          Array.isArray(menuTemplate) &&
          menuTemplate.length > 0 && (
            <div className='menu-container'>
              <div className='menu-entries-container'>
                <QuickReplyList
                  isFromMenu={true}
                  buttons={menuTemplate.map((menuEntry) => ({
                    title: menuEntry.title,
                    payload: menuEntry.payload,
                    type: menuEntry.type,
                  }))}
                  onClick={this.handleClick}
                  scheme={messageScheme}
                />
              </div>
              <PoweredBy />
            </div>
          )}
      </>
    );
  }
}

export default Menu;
